import { labelStyle, radioStyle } from '../../Signup.css';

interface RadioOptionProps {
  name: string;
  value: string;
  label: string;
  required?: boolean;
}

const RadioOption = ({ name, value, label, required }: RadioOptionProps) => (
  <div>
    <label
      className={labelStyle}
      style={{
        display: 'flex',
        gap: '6px',
        alignItems: 'center',
      }}
    >
      <input name={name} value={value} type="radio" defaultChecked={false} className={radioStyle} required={required} />
      <span>{label}</span>
    </label>
  </div>
);

export default RadioOption;
